import { useEffect } from 'react'
import { Modal } from 'almanac-ui/Modal'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button'
import { trackEventInHeap, HeapEventType } from 'utils/heapTracking'

interface RegenerateConfirmStepProps {
  isSaving: boolean
  onRegenerate: () => void
  onSkip: () => void
}

export const RegenerateConfirmStep = ({ isSaving, onRegenerate, onSkip }: RegenerateConfirmStepProps) => {
  useEffect(() => {
    trackEventInHeap(HeapEventType.VisualStylesForExistingUsers, {
      action: 'view-regenerate-step',
    })
  }, [])

  const handleSkip = () => {
    trackEventInHeap(HeapEventType.VisualStylesForExistingUsers, {
      action: 'click-save-for-future-content',
    })
    onSkip()
  }

  const handleRegenerate = () => {
    trackEventInHeap(HeapEventType.VisualStylesForExistingUsers, {
      action: 'click-save-and-regenerate',
    })
    onRegenerate()
  }

  return (
    <>
      <Modal.Header title="You're all set! When should we start creating your new content?" />
      <Modal.Content>
        <Text color="var(--dark-80)">
          Regenerate this week's unpublished posts with AI videos and stylized images, or apply these settings starting
          next week.
        </Text>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button variant="tertiary" size="lg" onPress={handleSkip} isDisabled={isSaving}>
            Start Next Week
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Button variant="primary" size="lg" onPress={handleRegenerate} isDisabled={isSaving}>
            {isSaving ? 'Saving...' : "Regenerate This Week's Content"}
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </>
  )
}
